import DriverContractsListRequest from "../../../../api/raily/driver/contracts/list/driver-contracts-list.request";
import DriverContractsListParams from "./driver-contracts-list-params";

const create = (
  params: DriverContractsListParams,
): DriverContractsListRequest => {
  return {
    driverUuid: params.driverUuid,
  };
};

const driverContractsListParamsFactory = {
  create,
};

export default driverContractsListParamsFactory;
